import { Type } from '@angular/core';
import { GroupItemType } from '@libs/form/models';
import { FormComponent } from './form';
import { InputListComponent } from './input-list';
import { StepComponent } from './step';

export type GroupItemComponent = StepComponent | FormComponent | InputListComponent;

export const GroupItemsMap: Record<GroupItemType, Type<GroupItemComponent>> = {
  form: FormComponent,
  step: StepComponent,
  list: InputListComponent,
};
